// Answers (as a string) the text content of a hyntax AST text element.
export default function text_content_of(hyntax_text) {
  return hyntax_text.content && hyntax_text.content.value && hyntax_text.content.value.content;
}
